import React from "react";
import {
  SuccessMessage,
  InstructionText,
  ResendButton,
  BackToLogin,
} from "./Login.styles.js";

const VerifyResetForm = ({
  email,
  countdown,
  resendEnabled,
  onResendEmail,
  switchToLogin,
}) => {
  return (
    <>
      <InstructionText>
        We've sent a password reset link to <strong>{email}</strong>. Click the
        link in the email to continue.
      </InstructionText>

      <div style={{ marginTop: "20px" }}>
        <InstructionText>Didn't receive the email?</InstructionText>
        <ResendButton onClick={onResendEmail} disabled={!resendEnabled}>
          {resendEnabled ? "Resend Email" : `Resend in ${countdown}s`}
        </ResendButton>
      </div>

      <BackToLogin onClick={switchToLogin}>← Back to Login</BackToLogin>
    </>
  );
};

export default VerifyResetForm;
